import DateConverter from "@heartinz/date_and_time_processor";
import uRLs from "../../utils/baseUtils";
import { parseAmount } from "./invoiceUtils";

export const getInvoiceConfig = (
  globalData,
  storeSettings,
  optData,
  settings,  
) => {
  const preSaleMode = globalData?.preSaleData?.preSaleMode?.toUpperCase();
  const isBill_isTax =
    storeSettings?.saleSettings?.saleModeSettings?.isBill_isTax;

  const selectedTheme = storeSettings?.invoiceSettings?.template;
  const selectedSize = storeSettings?.printerSettings?.paperSize;

  const isBill = globalData?.salemode?.toUpperCase() === "BILL";

  const isBillReceipt = isBill && isBill_isTax;

  const isProforma = preSaleMode === "PROFORMA_INVOICE";
  const timezone =
    globalData?.saleby?.timezone || settings?.mainStoreDetails?.timezone;

  const saleDate =
    globalData?.saledate ||
    globalData?.preSaleData?.preSaleUTCDate ||
    globalData?.returnSaleData?.saleReturnDate ||
    globalData?.purchaseDate;

  let saleTime = "--:--";
  let createdTime = {
    date: "--",
    time: "--",
  };

  if (saleDate) {
    const zoned = DateConverter.convertToTimeZone(saleDate, timezone);
    saleTime = DateConverter.ISOToDisplayFormat(zoned);
  }
  const createDate = !isProforma
    ? globalData?.createdAt
    : globalData?.preSaleData?.preSaleCreatedAt;

  if (createDate) {
    const zoned = DateConverter.convertToTimeZone(createDate, timezone);
    createdTime = DateConverter.ISOToDisplayFormat(zoned);
  }
  const isPurchase = !!globalData?.purchaseData;
  const isPreSale = ["PROFORMA_INVOICE", "ESTIMATION", "QUOTATION"].includes(
    preSaleMode,
  );

  const numberLabel = isPurchase
    ? "Purchase No: "
    : preSaleMode === "PROFORMA_INVOICE"
      ? "Proforma No: "
      : preSaleMode === "ESTIMATION"
        ? "Estimation No: "
        : preSaleMode === "QUOTATION"
          ? "Quotation No: "
          : isBill
            ? "Bill No: "
            : "Invoice No: ";

  const invoiceDate = isPurchase
    ? "Purchase Date: "
    : preSaleMode === "PROFORMA_INVOICE"
      ? "Proforma Date: "
      : preSaleMode === "ESTIMATION"
        ? "Estimation Date: "
        : preSaleMode === "QUOTATION"
          ? "Quotation Date: "
          : isBill
            ? "Bill Date: "
            : "Invoice Date: ";

  const invoiceTimeLabel = isPurchase
    ? "Purchase Time: "
    : preSaleMode === "PROFORMA_INVOICE"
      ? "Proforma Time: "
      : preSaleMode === "ESTIMATION"
        ? "Estimation Time: "
        : preSaleMode === "QUOTATION"
          ? "Quotation Time: "
          : isBill
            ? "Bill Time: "
            : "Invoice Time: ";
  const saleMode = globalData?.salemode?.trim()?.toUpperCase();

  const documentTitle =
    saleMode === "BILL"
      ? "BILL RECEIPT"
      : saleMode === "INVOICE"
        ? "TAX INVOICE"
        : preSaleMode === "PROFORMA_INVOICE"
          ? "PROFORMA INVOICE"
          : preSaleMode === "ESTIMATION"
            ? "ESTIMATION"
            : preSaleMode === "QUOTATION"
              ? "QUOTATION"
              : saleMode || preSaleMode;

  const documentConfig = isPreSale
    ? {
        title: documentTitle,
        numberLabel,
        dateLabel: invoiceDate,
        timeLabel: invoiceTimeLabel,
        fromLabel: "",
        Date: saleTime,
        fromData: globalData?.preSaleData?.billingStoreProfile,
        image:  globalData?.preSaleData?.billingStoreProfile?.image
                ? uRLs.IMAGE_URL +
                  "profile/" +
                  globalData.preSaleData.billingStoreProfile.image
                : "",
        toLabel: "Customer Details",
        toData: globalData?.preSaleData?.preSaleTo,
        paidAmount: globalData?.preSaleData?.paidAmount,
        number: globalData?.preSaleData?.preSaleNo,
        isPresaleConveror: globalData?.preSaleData?.preSaleTrack === "CONVERTED",
        items: globalData?.preSaleData?.preSaleItems,
        totalItems:globalData?.preSaleData?.totalItems,
        amountInWords: globalData?.preSaleData?.amountInWords,
        balanceDue: globalData?.preSaleData?.balanceDue,
        overallDiscount:globalData?.preSaleData?.overallDiscount,
        grandTotal: globalData?.preSaleData?.grandTotal,
        totalTaxAmount: globalData?.preSaleData?.totalTaxAmount,
        totalBasePrice: globalData?.preSaleData?.totalBasePrice,
        totalMrp: globalData?.preSaleData?.totalMrp,
        totalSoldPrice: globalData?.preSaleData?.totalSoldPrice,
        totalDiscount: globalData?.preSaleData?.totalDiscount,
        totalSalePrice: globalData?.preSaleData?.totalSalePrice,
        sgstAmount: globalData?.preSaleData?.sgstAmount,
        cgstAmount: globalData?.preSaleData?.cgstAmount,
        igstAmount: globalData?.preSaleData?.igstAmount,
        terms: globalData?.preSaleData?.terms,
        remarks: globalData?.preSaleData?.remarks,
      }
    : globalData?.returnSaleData
      ? {
          title: "CREDIT NOTE",
          numberLabel: "Credit No:",
          number: globalData?.returnSaleData?.saleReturnNo,
          saleNo: globalData?.returnSaleData?.saleNo,
          originalSaleDate: globalData?.returnSaleData?.originalSaleDate,
          Date: saleTime,
          dateLabel: invoiceDate,
          timeLabel: invoiceTimeLabel,
          saleId: globalData?.returnSaleData?.saleId,
          saleMode: globalData?.returnSaleData?.salemode,
          fromLabel: "",
          fromData: globalData?.returnSaleData?.billingStoreProfileData,
          image: globalData?.returnSaleData?.billingStoreProfile?.image
                ?uRLs.IMAGE_URL + "profile/" + globalData?.returnSaleData?.billingStoreProfileData?.image :"",
            

          toLabel: "Customer Details",
          toData: globalData?.returnSaleData?.customerData,
          returnGrandTotalRounded:
            globalData?.returnSaleData?.returnGrandTotalRounded,
          totalReturnAmount: globalData?.returnSaleData?.totalReturnAmount,
          totalSalePrice: globalData?.returnSaleData?.totalSalePrice,
          returnItems: globalData?.returnSaleData?.returnSaleItems,
          amountinwordsReturnRounded:
            globalData?.returnSaleData?.amountinwordsReturnRounded,
          amountinwordsTotalReturnAmount:
            globalData?.returnSaleData?.amountinwordsTotalReturnAmount,
          amountInWords:
            globalData?.returnSaleData?.amountinwordsTotalReturnAmount,
          actualAmountRefunded:
            globalData?.returnSaleData?.actualAmountRefunded,
          grandTotal: globalData?.returnSaleData?.returnGrandTotalRounded,
          totalTaxAmount: globalData?.returnSaleData?.totalTaxAmount,
          totalBasePrice: globalData?.returnSaleData?.totalBasePrice,
          totalSoldPrice: globalData?.returnSaleData?.totalSoldPrice,
          totalDiscount: globalData?.returnSaleData?.totalDiscount,
          totalMrp: globalData?.returnSaleData?.totalMrp,

          sgstAmount: globalData?.returnSaleData?.sgstAmount,
          cgstAmount: globalData?.returnSaleData?.cgstAmount,
          igstAmount: globalData?.returnSaleData?.igstAmount,

          cashPaid: globalData?.returnSaleData?.cashPaid,
          cardPaid: globalData?.returnSaleData?.cardPaid,
          onlinePaid: globalData?.returnSaleData?.onlinePaid,
          upiPaid: globalData?.returnSaleData?.upiPaid,
          balanceDue: globalData?.returnSaleData?.balanceDue,
          paidAmount: globalData?.returnSaleData?.paidAmount,
          terms: globalData?.returnSaleData?.terms,
          remarks: globalData?.returnSaleData?.remarks,

          bankDetails: globalData?.returnSaleData?.bankDetails,
          upiId: globalData?.returnSaleData?.upiId,
          upiQrLink: globalData?.returnSaleData?.upiQrLink,
        }
      : isPurchase
        ? {
            title: "PURCHASE ",

            numberLabel: "Purchase No: ",
            number: globalData?.purchaseData?.purchaseNo,

            dateLabel: "Purchase Date: ",
            timeLabel: "Purchase Time: ",

            Date: saleTime,
            supplierInfo:globalData?.supplierInfo,
            fromLabel: "",
            fromData: globalData?.purchaseData?.billingStoreProfile,
            image:  globalData?.purchaseData?.billingStoreProfile?.image
                ? uRLs.IMAGE_URL + "profile/" + globalData?.purchaseData?.billingStoreProfile?.image :"",

            toLabel: "Supplier Details",
            toData: globalData?.purchaseData?.supplierData,

            purchaseItems: globalData?.purchaseData?.purchaseItems,
            purchaseServices: globalData?.purchaseData?.purchaseServices,

            totalPurchaseMrp: globalData?.purchaseData?.totalPurchaseMrp,

            totalPurchasePrice: globalData?.purchaseData?.totalPurchasePrice,
            paidAmount: globalData?.purchaseData?.paidAmount,
            totalPurchasePriceWithoutTax:
              globalData?.purchaseData?.totalPurchasePriceWithoutTax,

            totalPurchaseDiscount:
              globalData?.purchaseData?.totalPurchaseDiscount,

            totalPurchaseTaxAmount:
              globalData?.purchaseData?.totalPurchaseTaxAmount,
            
            grandTotal:
              globalData?.grandTotal?.purchaseData?.grandtotal ??
              globalData?.totalAmount,

            sgstAmount: globalData?.purchaseData?.sgstPurchaseAmount,

            cgstAmount: globalData?.purchaseData?.cgstPurchaseAmount,

            igstAmount: globalData?.purchaseData?.igstPurchaseAmount,

            amountInWords:
              globalData?.grandTotal?.purchaseData?.purchaseAmountInWords ??
              globalData?.grandTotal?.totalPurchasePriceInWords,

            totalAmount: globalData?.purchaseData?.totalAmount,

            cashPaid: globalData?.purchaseData?.cashPaid,
            cardPaid: globalData?.purchaseData?.cardPaid,
            onlinePaid: globalData?.purchaseData?.onlinePaid,
            upiPaid: globalData?.purchaseData?.upiPaid,
            balanceDue: globalData?.purchaseData?.balanceDue,

            terms: globalData?.purchaseData?.terms,
            remarks: globalData?.purchaseData?.remarks,

            bankDetails: globalData?.bankDetails,
            upiId: globalData?.upiId,
            upiQrLink: globalData?.upiQrLink,
          }
        : {
            title: documentTitle,
            numberLabel,
            dateLabel: invoiceDate,
            timeLabel: invoiceTimeLabel,
            fromLabel: "",
            fromData: globalData?.salefrom,
            image:  globalData?.image
                ? uRLs.IMAGE_URL + "profile/" + globalData?.image :"",
            totalItems:globalData?.totalItems,
            Date: saleTime,
            toLabel: "Customer Details",
            toData: globalData?.saleto,
            saleId: globalData?._id,
            number: globalData?.saleno,

            items: globalData?.saleitems,

            amountInWords: globalData?.amountinwords,
            overallDiscount:globalData?.overallDiscount,
            grandTotal: globalData?.grandtotal,
            totalTaxAmount: globalData?.totaltaxamount,
            totalBasePrice: globalData?.totalbaseprice,
            totalSoldPrice: globalData?.totalsoldprice,
            totalDiscount: globalData?.totaldiscount,
            totalMrp: globalData?.totaldiscount,
            sgstAmount: globalData?.sgstamount,
            cgstAmount: globalData?.cgstamount,
            igstAmount: globalData?.igstamount,
            totalSalePrice: globalData?.totalsaleprice,
            cashPaid: globalData?.cashPaid,
            cardPaid: globalData?.cardPaid,
            onlinePaid: globalData?.onlinePaid,
            upiPaid: globalData?.upiPaid,
            balanceDue: globalData?.balanceDue,
            paidAmount: globalData?.paidAmount,
            terms: globalData?.terms,
            remarks: globalData?.remark,
            bankDetails: globalData.bankDetails,
            upiId: globalData.upiId,
            upiQrLink: globalData.upiQrLink,
          };

  const balanceDue =
    Number(globalData?.grandtotal || 0) - Number(globalData?.paidamount || 0);
  
  const fromStateCode= globalData?.preSaleData?.billingStoreProfile?.statecode ||
    globalData?.returnSaleData?.billingStoreProfileData?.statecode||
    globalData?.purchaseData?.DatebillingStoreProfile?.statecode ||
    globalData?.salefrom?.statecode

  const toStateCode= globalData?.preSaleData?.preSaleTo?.statecode ||
    globalData?.returnSaleData?.customerData?.statecode||
    globalData?.purchaseData?.supplierData?.statecode ||
    globalData?.saleto?.statecode


  const isInterState =
    fromStateCode &&
    toStateCode &&
    fromStateCode !== toStateCode;

  const hasPayment =
    parseAmount(documentConfig?.cashPaid) > 0 ||
    parseAmount(documentConfig?.cardPaid) > 0 ||
    parseAmount(documentConfig?.onlinePaid) > 0 ||
    parseAmount(documentConfig?.upiPaid) > 0 ||
    parseAmount(documentConfig?.balanceDue) > 0;
    
  const hasShipping =
    globalData?.saleto?.shippingAddress &&
    optData?.isCustomerDisplay &&
    (globalData?.saleto?.shippingAddress?.addressline1 ||
      globalData?.saleto?.shippingAddress?.addressline2);

  const formatTrackMode = (salemode) => {
    switch (salemode?.toUpperCase()) {
      case "BILL":
        return "BILL RECIEPT";
      case "INVOICE":
        return "TAX INVOICE";
      case "PROFORMA_INVOICE":
        return "PROFORMA_INVOICE";
      default:
        return salemode;
    }
  };

  const showTaxDetails =
    globalData?.salemode === "INVOICE" ||
    (isPreSale && optData?.withTax) ||
    isBillReceipt;

  const showBillDetails =
    globalData?.salemode === "BILL" || (isPreSale && !optData?.withTax);

  return {
    documentTitle,
    numberLabel,
    documentConfig,
    isReturnSale: !!globalData?.returnSaleData,
    isBill,
    isBillReceipt,
    isBill_isTax,
    isProforma,
    isPreSale,

    saleDate,
    timezone,

    balanceDue,

    isInterState,
    hasShipping,
    hasPayment,
    returnSaleTitle: "CREDIT NOTE",
    formatTrackMode,
    selectedTheme,
    isPurchase,
    globalData,
    saleTime,
    createdTime,
    selectedSize,

    showTaxDetails,
    showBillDetails,
  };
};
// sale?.salefrom?.image?.startsWith("/assets")
//     ? sale?.salefrom?.image
//     : uRLs?.IMAGE_URL + "profile/" + sale?.salefrom?.image